import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Header */}
      <section className="pad-2xl">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h1 className="heading-1 mb-6">Privacy Policy</h1>
            <p className="body-large mb-8" style={{ color: 'var(--text-secondary)' }}>
              Last updated: {new Date().toLocaleDateString('en-GB')}
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="pad-lg">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <div className="space-y-8">
              {/* Introduction */}
              <div>
                <h2 className="heading-2 mb-4">1. Introduction</h2>
                <p className="body-medium mb-4">
                  AutomationFirst ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. 
                  This privacy policy explains how we collect, use, and safeguard your information when you visit our website 
                  automation1st.com or use our services.
                </p>
              </div>

              {/* Information We Collect */}
              <div>
                <h2 className="heading-2 mb-4">2. Information We Collect</h2>
                <h3 className="heading-3 mb-3">2.1 Personal Information</h3>
                <ul className="space-y-2 mb-4">
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Name and contact details (email address, phone number)</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Company name and business information</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Communication preferences</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Audit questionnaire responses</span>
                  </li>
                </ul>

                <h3 className="heading-3 mb-3">2.2 Technical Information</h3>
                <ul className="space-y-2">
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>IP address and browser information</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Website usage data and analytics</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Device information and operating system</span>
                  </li>
                </ul>
              </div>

              {/* How We Use Your Information */}
              <div>
                <h2 className="heading-2 mb-4">3. How We Use Your Information</h2>
                <p className="body-medium mb-3">We use your personal information to:</p>
                <ul className="space-y-2">
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Provide automation consulting services</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Generate personalised audit reports</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Communicate about our services and respond to enquiries</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Improve our website and services</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Comply with legal obligations</span>
                  </li>
                </ul>
              </div>

              {/* Data Sharing */}
              <div>
                <h2 className="heading-2 mb-4">4. Data Sharing</h2>
                <p className="body-medium mb-3">
                  We do not sell, rent, or share your personal information with third parties except:
                </p>
                <ul className="space-y-2">
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>With your explicit consent</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>To comply with legal requirements</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>With trusted service providers who assist in our operations</span>
                  </li>
                </ul>
              </div>

              {/* Data Security */}
              <div>
                <h2 className="heading-2 mb-4">5. Data Security</h2>
                <p className="body-medium">
                  We implement appropriate technical and organisational measures to protect your personal data against 
                  unauthorised access, alteration, disclosure, or destruction. However, no method of transmission over 
                  the internet is 100% secure.
                </p>
              </div>

              {/* Your Rights */}
              <div>
                <h2 className="heading-2 mb-4">6. Your Rights</h2>
                <p className="body-medium mb-3">You have the right to:</p>
                <ul className="space-y-2">
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Access your personal data</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Correct inaccurate information</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Request deletion of your data</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Object to processing of your data</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Withdraw consent at any time</span>
                  </li>
                </ul>
              </div>

              {/* Contact Information */}
              <div>
                <h2 className="heading-2 mb-4">7. Contact Us</h2>
                <p className="body-medium mb-4">
                  If you have any questions about this Privacy Policy or wish to exercise your rights, please contact us:
                </p>
                <div className="bg-gray-50 p-6 rounded-lg">
                  <p className="body-medium mb-2">
                    <strong>Email:</strong> hello@automation1st.com
                  </p>
                  <p className="body-medium mb-2">
                    <strong>Phone:</strong> +91 9324280636
                  </p>
                  <p className="body-medium">
                    <strong>Address:</strong> Mumbai, India
                  </p>
                </div>
              </div>

              {/* Updates */}
              <div>
                <h2 className="heading-2 mb-4">8. Policy Updates</h2>
                <p className="body-medium">
                  We may update this Privacy Policy from time to time. We will notify you of any changes by posting 
                  the new Privacy Policy on this page and updating the "Last updated" date.
                </p>
              </div>
            </div>

            {/* Back to Home */}
            <div className="mt-12 text-center">
              <Link to="/" className="btn-secondary">
                Return to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;